import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import apiService from '../utils/api';

const FeaturedBlogs = () => {

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedPosts = async () => {
      try {
        const response = await apiService.getBlogPosts({ limit: 3, sort: 'newest' });
        setPosts(response.data.posts);
      } catch (err) {
        console.error('Error fetching featured posts:', err);
        setError('error in fetching blogs');
      } finally {
        setLoading(false);
      }
    };
    fetchFeaturedPosts();
  }, []);

  return (
    <section className="py-4 bg-gray-50 dark:bg-gray-900">
      <div className="container-custom px-4 mx-auto">
        {/* Header */}
    {  posts.length > 0 && (  <motion.div
          className="flex flex-col md:flex-row items-center md:justify-between mb-2"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >

          <h2 className="text-3xl md:text-3xl font-extrabold text-gray-900 dark:text-white mb-3 md:mb-0">
            Featured Blogs
          </h2>
          <Link
            to="/blog"
            className="flex items-center text-gray-900 dark:text-white font-semibold transition-colors"
          >
            View All Blogs
            <ChevronRight size={20} className="ml-1" />
          </Link>
        </motion.div>
)}
        {/* Content */}
       {posts.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {posts.map((post, i) => (
            <motion.div
              key={post.id}
              className="group relative rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
            >
              <Link to={`/news/${post.id}`}>
                {/* Image */}
                <div className="relative h-72 w-full">
                  <img
                    src={`https://backend.ysskytravel.com${post.image_url}`}
                    alt={post.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition duration-700"
                  />

                  {/* GRADIENT OVERLAY */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                  {/* DATE TOP RIGHT */}
                  <div className="absolute top-4 right-4 text-xs font-semibold text-white bg-black/40 backdrop-blur px-3 py-1 rounded-full">
                    {new Date(post.publish_date).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </div>

                  {/* TITLE ON IMAGE */}
                  <div className="absolute bottom-5 left-5 right-5">
                    <h3 className="text-2xl font-bold text-white leading-tight drop-shadow-xl line-clamp-2">
                      {post.title}
                    </h3>
                  </div>

                  {/* FEATURED BADGE */}
                  <span className="absolute top-4 left-4 bg-white/90 dark:bg-gray-800/80 px-4 py-1 rounded-full text-xs font-semibold text-gray-900 dark:text-gray-200 shadow">
                    Featured
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
        ) }
      </div>
    </section>
  );
};

export default FeaturedBlogs;
